import React, { useState } from "react";
import { LoginForm } from "react-animated-login-form";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { InfinitySpin } from 'react-loader-spinner';
import '../../index.css'; // Ensure the styles are included

const Login = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_LOGIN}`,
        { username: userName, password: password }
      );

      if (response.data.status) {
        setIsLoading(false);
        localStorage.setItem("auth_token", response.data.data.auth_token);
        localStorage.setItem("username", response.data.data.username);
        navigate("/admin");
      } else {
        setError(response.data.message);
      }
    } catch (error) {
      console.error("Login error:", error);
      setError("Login failed. Server is down, Please try again.");
      setIsLoading(false);
    }
  };

  return (
    <div className="App"> {/* Updated the class name to "App" */}
      <LoginForm
        title="Login"
        label="Username"
        type="text"
        value1={userName}
        value2={password}
        setValue1={setUserName}
        setValue2={setPassword}
        Submit={handleSubmit}
      />
      <div className="form-group form-button">
        {isLoading && !error && (
          <InfinitySpin
            visible={true}
            width="100"
            color="#89CFF0"
            ariaLabel="infinity-spin-loading"
          />
        )}
        {error && <p className="error-message mt-3 text-danger">{error}</p>}
      </div>
    </div>
  );
};

export default Login;
